import { PhnxAvatar } from '@/components/01-atoms/Avatar/Avatar'
import { stripNzLocale } from '@/utils/url'

import styles from './Authorcard.module.css'

export type AuthorcardProps = {
  asset?: {
    src: string
    alt: string
  }
  name: string
  bio?: React.ReactNode
  buttonURL?: string
  layout?: 'default' | 'compact'
}

export const PhnxAuthorcard: React.FC<AuthorcardProps> = ({
  asset,
  name,
  bio,
  buttonURL,
  layout = 'default',
}) => {
  const cleanedButtonURL = buttonURL ? stripNzLocale(buttonURL) : undefined

  // ensure that cleanedButtonURL always starts with a /
  const finalCleanedButtonURL = cleanedButtonURL?.startsWith('/')
    ? cleanedButtonURL
    : `/${cleanedButtonURL}`

  return (
    <div className={`${styles['author-card']} ${styles[`layout-${layout}`]}`}>
      {asset && asset.src && (
        <div className={styles['avatar-container']}>
          <PhnxAvatar
            size={layout == 'default' ? 'medium' : 'small'}
            style="circle"
            asset={{
              src: asset.src,
              alt: asset.alt,
            }}
          />
        </div>
      )}
      <div className="text-container">
        {name && (
          <div className={styles.name}>
            {layout == 'compact' && <>By </>}
            {name}
          </div>
        )}
        {bio && <div className={styles.bio}>{bio}</div>}
        {buttonURL &&
          buttonURL !== 'undefined' &&
          name !== 'Author: Findex Contributor | Author' && (
            <div className={styles.link}>
              <a href={finalCleanedButtonURL}>Read full profile</a>
            </div>
          )}
      </div>
    </div>
  )
}
